import * as React from "react";
import { Typography, Dialog, IconButton, Button, Box } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import { verbalTheme } from "../../layout/themes/verbal.theme";
import VerbalLogo from "../../../img/VerbalLogo";
import { useOrganisation } from "../../../hooks/useOrganisation";
import { useLocation } from "react-router-dom";
import { useAppNavigate } from "../../../hooks/useAppNavigate";

const SubscriptionSuccess: React.FC = () => {
    const [modalOpen, modalOpenSet] = React.useState(true);
    const { addSchoolOrganisation } = useOrganisation();
    const { push } = useAppNavigate();
    const { search } = useLocation();
    const subscriptionId = new URLSearchParams(search).get("subscription_id");

    React.useEffect(() => {
        const completeOnboarding = async () => {
            await addSchoolOrganisation({
                subscriptionId: subscriptionId,
            });
            modalOpenSet(true);
        };

        completeOnboarding();
    }, []);

    const closeModal = () => {
        modalOpenSet(false);
        push("/home");
    };

    const useStyles = makeStyles(
        createStyles({
            closeButton: {
                position: "absolute",
                right: verbalTheme.spacing(1.5),
                top: verbalTheme.spacing(1.5),
                background: verbalTheme.palette.success.main,
                color: verbalTheme.palette.common.white,
            },
        }),
    );

    const classes = useStyles();

    return (
        <>
            {modalOpen && (
                <Dialog onClose={closeModal} open={modalOpen}>
                    <Box mb={4} padding={2}>
                        <VerbalLogo color={"white"} width={"175px"} />
                    </Box>
                    <MuiDialogTitle>
                        <Typography variant="h4" component="h4">
                            Thank you for your subscription.
                        </Typography>
                        <IconButton
                            className={classes.closeButton}
                            aria-label="close"
                            onClick={closeModal}
                            size="large"
                        >
                            <CloseIcon />
                        </IconButton>
                    </MuiDialogTitle>
                    <MuiDialogContent>
                        <Button variant="contained" type="submit" size="large" color="primary" onClick={closeModal}>
                            Login
                        </Button>
                    </MuiDialogContent>
                </Dialog>
            )}
        </>
    );
};

export default SubscriptionSuccess;
